import flattenDeep from 'lodash.flattendeep';

/* eslint-disable max-len */
const seriesReducer = (curr, next) => {
  const p = curr.length ? curr[curr.length - 1] : Promise.resolve();
  curr.push(p.then(next));
  return curr;
};
const series = (a) => Promise.all(a.reduce(seriesReducer, []));

const pipe = (...functions) => (param) =>
  functions.reduce((prev, curr) => curr(prev), param);

const zip = (...arrays) => {
  const minLength = Math.min(...arrays.map((a) => a.length));
  const indices = [...Array(minLength).keys()];
  return indices.map((i) => arrays.map((a) => a[i]));
};

const strinfigyContent = (obj) => ({
  ...obj,
  content: JSON.stringify(obj.content),
});
const setWriterTo = (userId) => (section) => ({ ...section, writer: userId });
const onlyUsefulBits = ({ title, content, hidden, educatorOnly }) => ({
  title,
  content,
  hidden: Boolean(hidden),
  educatorOnly: Boolean(educatorOnly),
});
const setParent = (parentId) => (section) => ({ ...section, parent: parentId });

const prepareSection = (userId, parentId) =>
  pipe(
    onlyUsefulBits,
    strinfigyContent,
    setWriterTo(userId),
    setParent(parentId)
  );

const importItem = ({ userId, parentId, save }) => (item) =>
  save(prepareSection(userId, parentId)(item));

const importItems = ({ userId, save }) => (parentId, items) => {
  const importOne = importItem({ userId, parentId, save });
  const importQueue = items.map(importOne);
  return series(importQueue);
};

const v2Importer = async (save, userId, { material }) => {
  const importLevel = importItems({ userId, save });
  const importFolder = ([folderId, pages]) => () =>
    importLevel(folderId, pages);

  const folders = await importLevel(undefined, material);

  const folderIds = folders.map((folder) => folder.id);
  const allPages = material.map((folder) => folder.pages || []);
  const folderIdsAndPages = zip(folderIds, allPages);
  const pagePromises = [].concat(...folderIdsAndPages.map(importFolder));

  const savedPages = await series(pagePromises);

  return flattenDeep([...folders, ...savedPages]);
};

export default v2Importer;
